import PropTypes from "prop-types"
import { useState, useEffect } from "react"

import OrderNumber from "areas/order/order-number"
import { jewlr_t } from "helpers/application"

import { FormContainer, FormWrapper, Text } from "../components"
import Heading from "../heading"
import fetchOrder from "../hoc/fetch-order"

import Complete from "./complete"
import OrderForm from "./order-form"

const ChangeAddress = ({ data }) => {
  const [orderData, setData] = useState(null)
  const [completed, setCompleted] = useState(false)

  useEffect(() => {
    setData(data)
  }, [data])

  if (orderData && orderData.order) {
    if (completed) {
      return <Complete />
    } else {
      return <OrderForm orderData={orderData} setCompleted={setCompleted} />
    }
  }

  return (
    <FormContainer>
      <FormWrapper>
        <Heading rmaType="change-shipping-address" />
        <Text>
          Complete this form to change your {jewlr_t("terms.shipping")} address.
          Please note, this change can only be made if your order has not yet
          shipped. If you need further assistance, contact customer service at{" "}
          <a
            className="nowrap"
            href={`tel:${sl.config.customer_service_toll_free}`}
          >
            {sl.config.customer_service_toll_free}
          </a>{" "}
          or{" "}
          <a
            className="nowrap"
            href={`mailto:${sl.config.customer_service_email}`}
          >
            {sl.config.customer_service_email}
          </a>{" "}
          .
        </Text>
      </FormWrapper>
      <OrderNumber
        rmaType="change-shipping-address"
        setData={setData}
        validatePath="/secure/api/v10/order/prepare_address_change"
      />
    </FormContainer>
  )
}

ChangeAddress.propTypes = {
  data: PropTypes.object,
}

export default fetchOrder(ChangeAddress)
